// extracted by mini-css-extract-plugin
module.exports = {"rsaSpotifyBtn":"SpotifyAuth_rsaSpotifyBtn__2j6Wz","rsaSpotifyLogo":"SpotifyAuth_rsaSpotifyLogo__ixtGv"};